// src/pages/customer/ShippingPolicy.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const sections = [
  {
    title: "1. About Tripura Agro",
    body: "Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level. We are a team who understand crops, farmers, commodities and taste, curating a diverse product portfolio of rice, pulses, spices, wheat, soya, and value-added items — delivered with unparalleled quality and purity.",
  },
  {
    title: "2. Delivery Areas",
    body: "We currently deliver to selected areas in Odisha and nearby regions. During checkout, you can verify if your pincode falls within our serviceable area. We are actively working to expand our delivery network.",
  },
  {
    title: "3. Delivery Timeframe",
    body: "Orders are typically delivered within 1–3 business days from the date of order confirmation. Delivery times may vary depending on your location, product availability, and seasonal demand. You will receive a notification once your order is out for delivery.",
  },
  {
    title: "4. Delivery Charges",
    intro: "Delivery charges depend on your order value:",
    points: [
      "A flat delivery fee of ₹50 applies to orders below ₹500.",
      "Orders worth ₹500 or more qualify for free delivery.",
      "The applicable delivery charge will be clearly shown at checkout before you confirm your order.",
    ],
  },
  {
    title: "5. Order Tracking",
    body: "Once your order is dispatched, you will receive an update via email or SMS. For real-time tracking or delivery queries, you can contact our support team directly with your Order ID.",
  },
  {
    title: "6. Failed or Missed Deliveries",
    body: "If a delivery attempt fails due to an incorrect address or unavailability of the recipient, our delivery partner will attempt re-delivery. After two failed attempts, the order may be returned and a re-delivery charge may apply.",
  },
  {
    title: "7. Damaged in Transit",
    body: "If your order arrives damaged due to transit issues, please contact us within 24 hours with photo or video evidence. We will arrange a replacement or refund as per our Refund Policy.",
  },
  {
    title: "8. Delays",
    body: "Delivery timelines may be affected during public holidays, extreme weather events, or high-demand periods like festivals. We'll always keep you informed of any delays.",
  },
];

export default function ShippingPolicy() {
  return (
    <div style={{ background: "#f7f3e3" }}>
      <Helmet>
        <title>Shipping Policy | Tripura Agro</title>
        <meta
          name="description"
          content="Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level and the final customer, who may be an individual or an institution."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">

        <h1
          className="font-bold uppercase mb-8"
          style={{
            fontSize: "clamp(1.5rem, 3vw, 2rem)",
            color: "#2d3a1e",
            letterSpacing: "0.06em",
          }}
        >
          Shipping Policy
        </h1>

        <p className="text-sm sm:text-base leading-relaxed mb-10" style={{ color: "#444" }}>
          We deliver fresh, farm-sourced products straight to your doorstep. Here's everything you
          need to know about how we handle shipping and delivery.
        </p>

        <div className="space-y-9">
          {sections.map((s) => (
            <div key={s.title}>
              <h2
                className="font-bold uppercase mb-3"
                style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
              >
                {s.title}
              </h2>

              {s.intro && (
                <p className="text-sm sm:text-base leading-relaxed mb-3" style={{ color: "#444" }}>
                  {s.intro}
                </p>
              )}

              {s.body && (
                <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
                  {s.body}
                </p>
              )}

              {s.points && (
                <ul className="space-y-2">
                  {s.points.map((p, i) => (
                    <li
                      key={i}
                      className="text-sm sm:text-base leading-relaxed pl-5 relative"
                      style={{ color: "#444" }}
                    >
                      <span className="absolute left-0" style={{ color: "#4a6e30" }}>•</span>
                      {p}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}

          {/* Contact section */}
          <div>
            <h2
              className="font-bold uppercase mb-3"
              style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
            >
              9. Contact Us
            </h2>
            <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
              Delivery queries? Reach out to us at:
            </p>
            <p className="text-sm sm:text-base leading-relaxed mt-2" style={{ color: "#444" }}>
              Tripura Agro Industries OPC Pvt. Ltd.<br />
              Mail Id:{" "}
              <a href="mailto:sandeep@tripuraagro.com" style={{ color: "#4a6e30", fontWeight: 600 }}>
                sandeep@tripuraagro.com
              </a>
              <br />
              Contact No.:{" "}
              <a href="tel:+919778553533" style={{ color: "#4a6e30", fontWeight: 600 }}>
                +91 9778553533
              </a>
              <br />
              1st Floor, Panigrahy Complex, Janata Lane, Digapahandi, Ganjam, Odisha
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}